import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { DetailFormFieldShell } from '../../detail-form/DetailFormFieldShell';
import type { DetailFormCustomFieldRenderer } from '../../detail-form/types';
import { EMPLOYEE_REVIEW_RATING_FIELDS } from '../../colleagueRating/constants';

const ratingOptions = [
  { value: 1, label: '1 - Unsatisfactory' },
  { value: 2, label: '2 - Below Expectations' },
  { value: 3, label: '3 - Meets Expectations' },
  { value: 4, label: '4 - Exceeds Expectations' },
  { value: 5, label: '5 - Outstanding' },
];

export const renderEmployeeReviewRatingField: DetailFormCustomFieldRenderer = ({
  fieldName,
  metadata,
  field,
  disabled,
  isRequired,
  hideCaption,
  captionsWidth,
}) => {
  if (!EMPLOYEE_REVIEW_RATING_FIELDS.has(fieldName.toLowerCase())) return undefined;

  const error = field.state.meta.errors[0] as string | undefined;
  const label = `${metadata.title || metadata.caption || fieldName}${isRequired ? ' *' : ''}`;
  const labelId = `employee-review-rating-${fieldName}-label`;
  const value =
    field.state.value == null || field.state.value === '' ? '' : String(field.state.value);

  return (
    <DetailFormFieldShell
      label={label}
      hideCaption={hideCaption}
      captionsWidth={captionsWidth}
      error={error}
    >
      <FormControl fullWidth error={Boolean(error)} disabled={disabled}>
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
          labelId={labelId}
          value={value}
          label={label}
          onBlur={field.handleBlur}
          onChange={(event) => {
            const selectedValue = event.target.value;
            field.handleChange(selectedValue === '' ? '' : Number(selectedValue));
          }}
        >
          <MenuItem value="">Select Rating</MenuItem>
          {ratingOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </DetailFormFieldShell>
  );
};
